<div class="filters-mobile">
    <div class="filters-mobile__header">
        <h2 class="filters-mobile__header--title">Filters</h2>
        <button mat-button class="filters-mobile__header--reset" (click)="clearFilters()">Clear</button>
    </div>

    <div class="filters-mobile__content">
        <div class="filters-mobile__content--group">
            <label class="filters-mobile__content--label">Class</label>
            <div class="filters-mobile__content--form">
                @for (star of starsOptions; track $index) {
                    <mat-checkbox
                            [checked]="selectedFilters.stars.includes(star.value)"
                            (change)="onChangeArray($event, 'stars', star.value)"
                    >
                        {{ star.text }} stars
                    </mat-checkbox>
                }
            </div>
        </div>

        <div class="filters-mobile__content--group">
            <label class="filters-mobile__content--label">Rating</label>
            <div class="filters-mobile__content--form">
                <mat-radio-group [(ngModel)]="selectedFilters.score">
                    @for (score of scoreOptions; track $index) {
                        <mat-radio-button [value]="score.value">
                            {{ score.text }}
                        </mat-radio-button>
                    }
                </mat-radio-group>
            </div>
        </div>

        <div class="filters-mobile__content--group">
            <label class="filters-mobile__content--label">Price range</label>
            <div class="filters-mobile__content--form">
                <app-hotel-price-range-panel
                        class="initial"
                        [useAsComponent]="true"
                        [min]="selectedFilters.priceRange.min || 200"
                        [max]="selectedFilters.priceRange.max || 400"
                        (onApply)="priceChangeHandler($event)"
                ></app-hotel-price-range-panel>
            </div>
        </div>

        <div class="filters-mobile__content--group">
            <label class="filters-mobile__content--label">Accommodations</label>
            <div class="filters-mobile__content--form">
                @for (accom of accomondationOptions; track $index) {
                    <mat-checkbox
                            [checked]="selectedFilters.accomondation.includes(accom.value)"
                            (change)="onChangeArray($event, 'accomondation', accom.value)"
                    >
                        {{ accom.text }}
                    </mat-checkbox>
                }
            </div>
        </div>

        <div class="filters-mobile__content--group">
            <label class="filters-mobile__content--label">Facilities</label>
            <div class="filters-mobile__content--form">
                @for (facility of facilitiesOptions; track $index) {
                    <mat-checkbox
                            [checked]="selectedFilters.facilities.includes(facility.value)"
                            (change)="onChangeArray($event, 'facilities', facility.value)"
                    >
                        {{ facility.text }}
                    </mat-checkbox>
                }
            </div>
        </div>

        <div class="filters-mobile__content--group">
            <label class="filters-mobile__content--label">Sorting</label>
            <div class="filters-mobile__content--form">
                <mat-radio-group [(ngModel)]="selectedFilters.sorting">
                    @for (sort of sortingOptions; track $index) {
                        <mat-radio-button [value]="sort.value">
                            {{ sort.text }}
                        </mat-radio-button>
                    }
                </mat-radio-group>
            </div>
        </div>

        <div class="filters-mobile__content--group">
            <label class="filters-mobile__content--label">Popular filters</label>
            <div class="filters-mobile__content--form">
                <mat-checkbox [(ngModel)]="selectedFilters.refundable">Free Cancellation</mat-checkbox>
                <mat-checkbox [(ngModel)]="selectedFilters.breakfastIncluded">Breakfast Included</mat-checkbox>
            </div>
        </div>
    </div>

    <div class="filters-mobile__footer">
        <button class="btn-default btn-blue filters-mobile__footer--apply" (click)="applyFilters()">Apply</button>
    </div>
</div>
